"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendMessageAndImmediatelyExecute = exports.process = exports.test = exports.read = exports.write = exports.voyageMessageId = exports.EEffectCommand = void 0;
var assert_sidecar_1 = require("@lib/assert-sidecar");
var voyageCamera_shaker_sidecar_1 = require("@voyage/camera/voyageCamera_shaker-sidecar");
var voyageParticles_sidecar_1 = require("@voyage/particles/voyageParticles-sidecar");
var voyageSounds_sidecar_1 = require("@voyage/sounds/voyageSounds-sidecar");
var voyageMessageIds_1 = require("./voyageMessageIds");
var messageWriter_sidecar_1 = require("@engine/messageWriter-sidecar");
var websockets_sidecar_1 = require("@engine/websockets-sidecar");
var EEffectCommand;
(function (EEffectCommand) {
    EEffectCommand[EEffectCommand["HitFire"] = 1] = "HitFire";
    EEffectCommand[EEffectCommand["HitBreach"] = 2] = "HitBreach";
    EEffectCommand[EEffectCommand["Shake"] = 3] = "Shake";
    EEffectCommand[EEffectCommand["HitExplosion"] = 4] = "HitExplosion";
    EEffectCommand[EEffectCommand["HitParticles"] = 5] = "HitParticles";
})(EEffectCommand = exports.EEffectCommand || (exports.EEffectCommand = {}));
exports.voyageMessageId = voyageMessageIds_1.EVoyageMessage.EffectCommand;
function write(m, d) {
    messageWriter_sidecar_1.messageWriter.write8(m, exports.voyageMessageId);
    messageWriter_sidecar_1.messageWriter.write8(m, d.command);
    messageWriter_sidecar_1.messageWriter.writeFloat(m, d.x || 0);
    messageWriter_sidecar_1.messageWriter.writeFloat(m, d.y || 0);
    messageWriter_sidecar_1.messageWriter.write8(m, d.num || 0);
}
exports.write = write;
function read(m) {
    var t = messageWriter_sidecar_1.messageWriter.read8(m);
    assert_sidecar_1.assert.eq(t, exports.voyageMessageId);
    var d = {
        command: messageWriter_sidecar_1.messageWriter.read8(m),
        x: messageWriter_sidecar_1.messageWriter.readFloat(m),
        y: messageWriter_sidecar_1.messageWriter.readFloat(m),
        num: messageWriter_sidecar_1.messageWriter.read8(m),
    };
    return d;
}
exports.read = read;
function test() {
    var ex = {
        command: EEffectCommand.HitBreach,
        x: 32,
        y: 123,
        num: 10,
    };
    messageWriter_sidecar_1.messageWriter.test('effect-command', ex, write, read);
}
exports.test = test;
function process(m) {
    var msg = read(m);
    if (msg.command === EEffectCommand.HitBreach) {
        voyageSounds_sidecar_1.voyageSounds.playExplosionMetalDebris();
    }
    if (msg.command === EEffectCommand.HitFire) {
        voyageSounds_sidecar_1.voyageSounds.playExplosionFire();
    }
    if (msg.command === EEffectCommand.HitExplosion) {
        voyageSounds_sidecar_1.voyageSounds.playExplosion();
    }
    if (msg.command === EEffectCommand.Shake) {
        voyageCamera_shaker_sidecar_1.voyageCamera_shaker.shake();
    }
    if (msg.command === EEffectCommand.HitParticles) {
        voyageParticles_sidecar_1.voyageParticles.createMultiple('weapon-hit', msg.x || 0, msg.y || 0, msg.num || 1); // 5 * size)
    }
    // if (msg.command === EHostCommand.Reset) {
    //   voyageGameMode_game.reset()
    // }
}
exports.process = process;
function sendMessageAndImmediatelyExecute(msg) {
    websockets_sidecar_1.websockets._sendMessageAndImmediatelyExecute(write, msg);
}
exports.sendMessageAndImmediatelyExecute = sendMessageAndImmediatelyExecute;
